"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var alwaysMoveToFocusedOtherService_1 = require("../services/alwaysMoveToFocusedOtherService");
var owa_confirm_dialog_1 = require("owa-confirm-dialog");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var createSetItemField_1 = require("owa-mail-store/lib/services/utils/createSetItemField");
var createOrUpdateFocusedOtherOverrideService_1 = require("owa-mail-triage-action/lib/services/createOrUpdateFocusedOtherOverrideService");
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var datapoints_1 = require("./datapoints");
var owa_mail_list_store_2 = require("owa-mail-list-store");
var moveMailListRowsToFocusedOrOther_1 = require("owa-mail-triage-action/lib/actions/moveMailListRowsToFocusedOrOther");
/**
 * Always move row from sender to focused/other action
 * @param rowKeys the rowws currently selected
 * @param tableView the table view
 * @param actionSource source of the action
 * @return the action response
 */
exports.default = legacy_1.action('alwaysMoveRowToFocusedOrOtherInternal', datapoints_1.default.alwaysMoveRowToFocusedOrOtherDatapoint)(function alwaysMoveRowToFocusedOrOtherInternal(rowKeys, tableView, actionSource) {
    var senderSMTPAddress = owa_mail_list_store_2.MailRowDataPropertyGetter.getLastSenderSMTP(rowKeys[0], tableView);
    if (senderSMTPAddress == null) {
        return;
    }
    var inferenceClassification;
    var focusedFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    switch (focusedFilter) {
        case 0 /* Focused */:
            inferenceClassification = 'Other';
            break;
        case 1 /* Other */:
            inferenceClassification = 'Focused';
            break;
        case -1 /* None */:
            throw new Error('FocusedViewFilter.None is not supported for this action');
    }
    // Show confirmation dialog
    owa_confirm_dialog_1.confirm(null, owa_strings_1.format(owa_mail_strings_1.default.alwaysMoveConfirmationText, senderSMTPAddress, inferenceClassification)).then(function (response) {
        if (response === 0 /* ok */) {
            // Since row may have been deleted from the table while the confirm dialog was open,
            // we need to validate the rows again before performing the operation.
            if (tableView.rowKeys.indexOf(rowKeys[0]) > -1) {
                // Only proceed if the selected row hasn't changed
                createOverrideAndSweepRow(rowKeys[0], senderSMTPAddress, inferenceClassification, tableView);
            }
        }
    });
});
/**
 * Create override and sweep row from sender to Focused/Other
 * @param rowKey to be acted upon
 * @param senderSMTPAddress the smtp address of the sender
 * @param inferenceClassification the new inference to set for this sender
 * @param tableView to which row belongs
 */
function createOverrideAndSweepRow(rowKey, senderSMTPAddress, inferenceClassification, tableView) {
    // Move row to Focused or Other
    moveMailListRowsToFocusedOrOther_1.default([rowKey], tableView.id, 'AlwaysMoveToFocusedOther');
    // Create override to move future rows from sender to Focused or Other
    createOrUpdateFocusedOtherOverrideService_1.createOrUpdateFocusedOtherOverrideService(senderSMTPAddress, inferenceClassification);
    // Sweep existing rows from the sender to target Focused or Other
    alwaysMoveToFocusedOtherService_1.alwaysMoveToFocusedOtherService({
        Id: tableView.serverFolderId,
    }, [{ EmailAddress: senderSMTPAddress }], createSetItemField_1.default('InferenceClassification', inferenceClassification));
}
//# sourceMappingURL=alwaysMoveRowToFocusedOrOther.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/alwaysMoveRowToFocusedOrOther.js
// module id = 5628
// module chunks = 62